/**
 * @file
 * A JavaScript file for Anchor Platform front-end functions.
 *
 */

"use strict";

(function($, Drupal) {
	$(document).ready(function() {
		hideAccordionTillAfterLoad()
		toggleNav()
		togglePagesList()
		scrollToTop()
		removeMultipleExposedFilters()
		customerDropdown()
		inputHasValue()
		actionsDropdown()
		dummyAccordions()
		displayToggles()
		moveRevisionLog()
		sailingFakeCheckbox()
		useInttraToggle()
		inttraToggle()
		natureOfCargoToggle()
		stickySidebar()
		openChangeRequest()
		documentationSaveButtonClone()
	});

	function hideAccordionTillAfterLoad() {
		if ( $('.field-group-accordion').length ) {
			$('.field-group-accordion').css('opacity', '1')
		}
	}

	function toggleNav() {
		$("#js-mobile-menu").click((e) => {
			document.body.classList.toggle('nav-open')
		})
	}

	function togglePagesList() {
		$(".pages-list span").click((e) => {
			e.currentTarget.parentElement.parentElement.classList.toggle('open')

			if( $('.submenu.open').length ) {
				$('.submenu.open').removeClass('open')
				$('.actions-container .arrow-logo').removeClass('flip')
			}
		})
	}

	function scrollToTop() {
      $('.back-to-top a').click((e) => {
        e.preventDefault()
        scroller()
      })
      
      const scroller = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop
        if (c > 0) {
          window.requestAnimationFrame(scroller)
          window.scrollTo(0, c - c / 8)
        }
      };
    }

    function removeMultipleExposedFilters() {
    	// $(".pages-list #views-exposed-form-dashboard-page").find('#edit-field-customer-tid-wrapper, #edit-field-manual-etd-value-wrapper').remove()
    	// $(".view-dashboard #views-exposed-form-dashboard-page").find('#edit-keys-wrapper').remove()
    }

	function customerDropdown() {
		$(window).click( (e) => {
			if ( document.body.classList.contains('customer-nav') ) {
				let openCustomers = document.getElementsByClassName('show')

				if( !e.target.classList.contains('dropbtn') ) {
					Object.entries(openCustomers).forEach(([i, el]) => {
						el.classList.remove('show')
					})

					document.body.classList.remove('customer-nav')
				} else {
					dropbtn(e.target)
				}
			}
		})

		$('.dropbtn').click( (e) => {
			dropbtn(e.currentTarget)
		})

		function dropbtn(elem) {
			let openCustomers = document.getElementsByClassName('show')
			
			Object.entries(openCustomers).forEach(([i, el]) => {
				el.classList.remove('show')
			})

			document.body.classList.add('customer-nav')
			elem.nextElementSibling.classList.add('show')
		}
	}

	function inputHasValue() {
		document.addEventListener('change', (e) => {
			if ((e.srcElement.localName === 'input' && e.srcElement.value !== '') || (e.srcElement.localName === 'textarea' && e.srcElement.value !== '')) {
				e.srcElement.parentElement.classList.add('hasValue')
			} else {
				e.srcElement.parentElement.classList.remove('hasValue')
			}
		})
	}

	function actionsDropdown() {
		$('.actions-container .arrow-logo').click( (e) => {
			e.currentTarget.classList.toggle('flip')

			if ( e.currentTarget.parentElement.previousElementSibling ) {
				e.currentTarget.parentElement.previousElementSibling.classList.toggle('open')
			}

			if ( e.currentTarget.parentElement.nextElementSibling ) {
				e.currentTarget.parentElement.nextElementSibling.classList.toggle('open')
			}

			if( $('.pages-list.open').length ) {
				$('.pages-list.open').removeClass('open')
			}
		})
	}

	function dummyAccordions() {
		let dummyAccordions = document.querySelectorAll('.accordion')

		Object.entries(dummyAccordions).forEach(([i, el]) => {
			if ( el.classList.contains('open') ) {
				document.body.classList.add('accordion-open')
			}

			$(el.firstElementChild).click((e) => {
				if ( e.currentTarget.parentElement.classList.contains('open') ) {
					e.currentTarget.parentElement.classList.remove('open')

					if ( !$('.accordion.open').length ) {
						document.body.classList.remove('accordion-open')
						$('#toggle-all p').html('Expand all')
					}
				} else {
					e.currentTarget.parentElement.classList.add('open')
					document.body.classList.add('accordion-open')
					$('#toggle-all p').html('Collapse all')
				}
			})
		})

		$('#toggle-all').click( (e) => {
			if( document.body.classList.contains('accordion-open') ) {
				document.body.classList.remove('accordion-open')
				e.currentTarget.children[0].innerText = 'Expand all'

				Object.entries(dummyAccordions).forEach(([i, el]) => {
					el.classList.remove('open')
				})
			} else {
				document.body.classList.add('accordion-open')
				e.currentTarget.children[0].innerText = 'Collapse all'

				Object.entries(dummyAccordions).forEach(([i, el]) => {
					el.classList.add('open')
				})
			}
		})
	}

	function displayToggles() {
		$('#toggle-inttra').click( (e) => {
			document.body.classList.toggle('hide-inttra')
		})

		$('#toggle-requested').click( (e) => {
			document.body.classList.toggle('hide-requested')
		})
	}

	function moveRevisionLog() {
		if ( $('fieldset.node-form-revision-information').length ) {
			$('fieldset.node-form-revision-information').appendTo('#notes-references .accordion .accordion-fields')
		}
	}

	function sailingFakeCheckbox() {
		if ( $('#edit-field-sailing-confirmed-und').length ) {
			if ( $('#edit-field-sailing-confirmed-und').is(":checked") ) {
				$('#active-sc').removeClass('sailing-confirmed-No').addClass('sailing-confirmed-Yes')
				$('#active-sc .status-light').removeClass('sailing-No').addClass('sailing-Yes')
			} else {
				$('#active-sc').removeClass('sailing-confirmed-Yes').addClass('sailing-confirmed-No')
				$('#active-sc .status-light').removeClass('sailing-Yes').addClass('sailing-No')
			}
				
			$('#active-sc').click( (e) => {
				$('#edit-field-sailing-confirmed-und').click()
				
				if ( $('#edit-field-sailing-confirmed-und').is(":checked") ) {
					$('#active-sc').removeClass('sailing-confirmed-No').addClass('sailing-confirmed-Yes')
					$('#active-sc .status-light').removeClass('sailing-No').addClass('sailing-Yes')
				} else {
					$('#active-sc').removeClass('sailing-confirmed-Yes').addClass('sailing-confirmed-No')
					$('#active-sc .status-light').removeClass('sailing-Yes').addClass('sailing-No')
				}
			})
		}
	}

	function useInttraToggle() {
		if ( $('input#edit-field-use-inttra-und').length ) {
			document.addEventListener('change', (e) => {
				if (e.target.id == 'edit-field-use-inttra-und') {
					inttraToggle()
				}
			})
		}
	}

	function inttraToggle() {
		stickySidebar()
		
		if ( $('input#edit-field-use-inttra-und').length ) {
			if ( $('input#edit-field-use-inttra-und').is(":checked") ) {
				document.body.classList.add('inttra-active')
				document.body.classList.remove('hide-inttra')
				natureOfCargo()
			} else {
				document.body.classList.remove('inttra-active')
				document.body.classList.add('hide-inttra')
			}
		}
	}

	function natureOfCargoToggle() {
		if ( $('#edit-field-anchor-natureofcargo-und').length ) {
			document.addEventListener('change', (e) => {
				if (e.target.id == 'edit-field-anchor-natureofcargo-und') {
					natureOfCargo()
				}
			})
		}
	}

	function natureOfCargo() {
		let cargo = document.getElementById('edit-field-anchor-natureofcargo-und')
		
		if ( $('input#edit-field-use-inttra-und').is(":checked") ) {
			if( cargo.value === 'Hazardous' ) {
				alert('At this point you cannot use Inttra with Hazardous Bookings')
				document.querySelector('#edit-field-anchor-natureofcargo-und [value="_none"]').selected = true;

				if ( !$('#edit-field-contains-hazardous-materia-und').is(":checked") ) {
					$("#edit-field-contains-hazardous-materia-und").click()
					$('input#edit-field-use-inttra-und').click()
				}
			} else {
				if ( $('#edit-field-contains-hazardous-materia-und').is(":checked") ) {
					$("#edit-field-contains-hazardous-materia-und").click()
				}
			}
		}
	}

	function stickySidebar() {
		if ( $('#sticky-col').length ) {
			const sidebar = document.getElementById('sticky-col')
			const header  = document.getElementById('top')
			const navbar  = document.getElementsByClassName("pages-list")[0]
			const title   = document.getElementsByClassName("bookings-header")[0]
			const footer  = document.getElementById('footer')
			let lastScrollTop = document.documentElement.scrollTop
			sidebar.parentElement.style.position ="relative"

			$(window).on("resize scroll", (e) => {
				if (document.documentElement.clientWidth > 1023) {	
					let st = window.pageYOffset || document.documentElement.scrollTop
					let stickTop = header.clientHeight + navbar.clientHeight + title.clientHeight + 20

					// If scrolling down then
					// if (st > lastScrollTop) {
					// 	sidebar.style.position = "relative"
					// 	sidebar.style.top = 'auto'
					// 	sidebar.style.bottom = 'auto'
					// }

					// // If scrolling up
					// else {					
					// 	// Set top of element to top of viewport If scrolled above top of element
					// 	sidebar.style.position = "relative"
					// 	sidebar.style.top = 'auto'
					// 	sidebar.style.bottom = 'auto'	
					// }

					sidebar.style.position = "relative"
					sidebar.style.top = 'auto'
					sidebar.style.bottom = 'auto'	

					// Set bottom of element at bottom of viewport If scrolled past bottom of element
					if ( (document.documentElement.clientHeight - sidebar.getBoundingClientRect().bottom) > 20) {
						sidebar.style.position = "fixed"
						sidebar.style.top = 'auto'
						sidebar.style.bottom = '20px'

						// Make the element push up if footer starts overlapping regardless of scroll direction
						if ( document.documentElement.scrollHeight - document.documentElement.scrollTop < footer.clientHeight + document.documentElement.clientHeight ) {
							sidebar.style.position = "absolute"
							sidebar.style.top = 'auto'
							sidebar.style.bottom = '10px'
						}
					}

					// Just keep it fixed to the top if it can fit regardless of scroll direction
					if ( sidebar.clientHeight < document.documentElement.clientHeight - (header.clientHeight + navbar.clientHeight + title.clientHeight) ) {
						sidebar.style.position = "fixed"
						sidebar.style.top = stickTop + 'px'
						sidebar.style.bottom = 'auto'
					}

					lastScrollTop = st <= 0 ? 0 : st; 
				} else {
					sidebar.style.position = "relative"
					sidebar.style.top = 'auto'
					sidebar.style.bottom = 'auto'
				}
			})
		}
	}

	function openChangeRequest() {
		if ( $('.modalChangeRequest').length ) {
			$('.show-change-box').click( (e) => {
				document.body.classList.add('change-req-open')
			})

			$('.modal-fade-screen, .modal-close').click( (e) => {
				document.body.classList.remove('change-req-open')
			})
		}
	}

	function documentationSaveButtonClone() {
		if ( $('body.page-field-collection-field-documentation').length ) {
			const saveBtn = document.getElementById('edit-submit')
			const container = document.querySelector('.view-booking-info')
			var btn = document.createElement("button")
			btn.innerHTML = "Save";
			btn.classList.add('btn')
			$(btn).css({
				'marginTop' : '10px',
				'float' : 'left'
			})
			$(btn).click( (e) => {
				$('#edit-submit').click()
				e.currentTarget.classList.add('disabled')
			})

			container.appendChild(btn)
		}
	}

})(jQuery, Drupal)